<template>
    <div class="container" :style="{ backgroundImage: 'url(' + imgUrl + ')' }">
        <div class="box">
            <div class="item reveal-bottom">
                {{ $t("mob.f") }}
            </div>
            <div class="item reveal-bottom">
                {{ $t("mob.f1") }}
            </div>
            <div class="item reveal-bottom">
                {{ $t("mob.f2") }}
            </div>
            <div class="item reveal-bottom">
                {{ $t("mob.f3") }}
            </div>
        </div>
    </div>
</template>
<script>
export default {
    name: "content1",
    data() {
        return {
            imgUrl: require("@/assets/images/mobile_client.png"),
        };
    },
};
</script>
<style scoped>
.container {
    height: 760px;
    background-size: cover;
    background-repeat: no-repeat;
    background-position: center;
    overflow: hidden;
}
.box {
    width: 1200px;
    margin: 220px auto;
    padding: 0 10px;
    box-sizing: border-box;
    display: flex;
    flex-wrap: wrap;
    justify-content: space-between;
}
.item {
    width: 482px;
    height: 88px;
    font-size: 22px;
    color: #ffffff;
    line-height: 44px;
    font-weight: bold;
}
.item:nth-child(1),
.item:nth-child(2) {
    margin-bottom: 132px;
}
</style>



// WEBPACK FOOTER //
// src/Pages/MobileClient/Content1.vue